module.exports = __webpack_public_path__ + "media/images/page/photo_sample2-m-d4035296846832a83f481d3e29bbdead.jpg";